import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/api/client";
import type { SiteAthenaMapping } from "@/api/types";

const KEY = ["site-athena-mappings"] as const;

export function useSiteAthenaMappings() {
  return useQuery<SiteAthenaMapping[]>({
    queryKey: KEY,
    queryFn: () => apiRequest("/api/site-athena-mappings"),
  });
}

interface CreatePayload {
  site_id: string;
  domain: string;
  table_name: string;
  date_column: string;
  notes?: string | null;
}

export function useCreateSiteAthenaMapping() {
  const qc = useQueryClient();
  return useMutation<SiteAthenaMapping, Error, CreatePayload>({
    mutationFn: (payload) =>
      apiRequest("/api/site-athena-mappings", {
        method: "POST",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

interface UpdatePayload {
  id: string;
  table_name?: string;
  date_column?: string;
  notes?: string | null;
}

export function useUpdateSiteAthenaMapping() {
  const qc = useQueryClient();
  return useMutation<SiteAthenaMapping, Error, UpdatePayload>({
    mutationFn: ({ id, ...patch }) =>
      apiRequest(`/api/site-athena-mappings/${id}`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteSiteAthenaMapping() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) =>
      apiRequest(`/api/site-athena-mappings/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
